import { FC } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from 'recharts';
import dayjs from 'dayjs';
import { IReadinessIndexMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: IReadinessIndexMetric | null;
  period?: string;
  height?: number;
}

export const ReadinessIndexChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.series || data.series.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <LineChart data={data.series} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis domain={[0, 100]} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(value) => [value, 'Readiness']}
          labelFormatter={(label) => dayjs(label).format('DD/MM/YYYY')}
        />
        <ReferenceLine
          y={60}
          stroke="var(--c-yellow)"
          strokeDasharray="4 3"
          label={{ value: 'Soglia', fontSize: 10, fill: 'var(--c-yellow)', position: 'right' }}
        />
        <Line type="monotone" dataKey="value" stroke="#5BC9E0" strokeWidth={2} dot={false} />
        {data.injuryMarkers?.map((marker) => (
          <ReferenceLine key={marker.injuryId} x={marker.date} stroke="var(--ri-critical)" strokeWidth={1.5} />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};
